import {
  AccessTimeOutlined,
  AcUnitOutlined,
  BakeryDiningOutlined,
  CalendarMonthOutlined,
  DeviceThermostatOutlined,
  EmojiNatureOutlined,
  Inventory2Outlined,
  LocalDrinkOutlined,
  LocalOfferOutlined,
  NatureOutlined,
  PlaceOutlined,
  SpaOutlined,
  StarOutlineRounded,
  TrendingUpOutlined,
  WorkspacePremiumOutlined,
  YardOutlined,
} from '@mui/icons-material';
import { ElementType } from 'react';
import { ItemTagIconKey } from '../../../../app/services/api/itemTags';

export type MaterialIconOption = {
  key: string;
  label: string;
  searchText: string;
  Icon: ElementType;
};

const legacyIconAliases: Record<string, string> = {
  eco: 'NatureOutlined',
  localOffer: 'LocalOfferOutlined',
  inventory: 'Inventory2Outlined',
  star: 'StarOutlineRounded',
  bolt: 'TrendingUpOutlined',
  favorite: 'StarOutlineRounded',
  newReleases: 'StarOutlineRounded',
  verified: 'WorkspacePremiumOutlined',
  organic: 'NatureOutlined',
  frozen: 'AcUnitOutlined',
  sale: 'LocalOfferOutlined',
  popular: 'TrendingUpOutlined',
  dairy: 'LocalDrinkOutlined',
  bakery: 'BakeryDiningOutlined',
  fruit: 'EmojiNatureOutlined',
  vegetarian: 'SpaOutlined',
  local: 'PlaceOutlined',
  seasonal: 'CalendarMonthOutlined',
  limited: 'AccessTimeOutlined',
  premium: 'WorkspacePremiumOutlined',
  chilled: 'DeviceThermostatOutlined',
  bulk: 'Inventory2Outlined',
  fresh: 'YardOutlined',
};

export const MATERIAL_ICON_OPTIONS: MaterialIconOption[] = [
  { key: 'NatureOutlined', label: 'Organic', searchText: 'organic leaf nature eco green', Icon: NatureOutlined },
  { key: 'AcUnitOutlined', label: 'Frozen', searchText: 'frozen cold snowflake ice', Icon: AcUnitOutlined },
  { key: 'StarOutlineRounded', label: 'New', searchText: 'new star launch', Icon: StarOutlineRounded },
  { key: 'LocalOfferOutlined', label: 'Sale', searchText: 'sale discount offer tag', Icon: LocalOfferOutlined },
  { key: 'TrendingUpOutlined', label: 'Popular', searchText: 'popular trending best seller', Icon: TrendingUpOutlined },
  { key: 'LocalDrinkOutlined', label: 'Dairy', searchText: 'dairy milk drink', Icon: LocalDrinkOutlined },
  { key: 'BakeryDiningOutlined', label: 'Bakery', searchText: 'bakery bread pastry', Icon: BakeryDiningOutlined },
  { key: 'EmojiNatureOutlined', label: 'Fruit', searchText: 'fruit apple produce', Icon: EmojiNatureOutlined },
  { key: 'SpaOutlined', label: 'Vegetarian', searchText: 'vegetarian plant veg', Icon: SpaOutlined },
  { key: 'PlaceOutlined', label: 'Local', searchText: 'local nearby location', Icon: PlaceOutlined },
  { key: 'CalendarMonthOutlined', label: 'Seasonal', searchText: 'seasonal calendar month', Icon: CalendarMonthOutlined },
  { key: 'AccessTimeOutlined', label: 'Limited', searchText: 'limited time clock', Icon: AccessTimeOutlined },
  { key: 'WorkspacePremiumOutlined', label: 'Premium', searchText: 'premium quality award', Icon: WorkspacePremiumOutlined },
  { key: 'DeviceThermostatOutlined', label: 'Chilled', searchText: 'chilled cool temperature', Icon: DeviceThermostatOutlined },
  { key: 'Inventory2Outlined', label: 'Bulk', searchText: 'bulk package box quantity', Icon: Inventory2Outlined },
  { key: 'YardOutlined', label: 'Fresh', searchText: 'fresh sprout farm', Icon: YardOutlined },
];

export const DEFAULT_ITEM_TAG_COLORS = {
  textColor: '#1F3B08',
  backgroundColor: '#A8E4A7',
};

const HEX_COLOR_REGEX = /^#[0-9A-F]{6}$/;

export const normalizeHexColor = (value: string) => value.trim().toUpperCase();

export const isValidHexColor = (value: string) => HEX_COLOR_REGEX.test(normalizeHexColor(value));

const materialIconOptionMap = new Map(
  MATERIAL_ICON_OPTIONS.map((option) => [option.key, option]),
);

const resolveMaterialIconKey = (iconKey: string) => legacyIconAliases[iconKey] ?? iconKey;

export const findMaterialIconOption = (iconKey: string) =>
  materialIconOptionMap.get(resolveMaterialIconKey(iconKey)) ?? null;

export const resolveMaterialIcon = (iconKey: ItemTagIconKey): ElementType => {
  const resolvedIconOption = findMaterialIconOption(iconKey);
  return resolvedIconOption?.Icon ?? LocalOfferOutlined;
};
